import { BaseLayoutFactory } from "../global/base-layout-factory";
import { PublicationsProvider } from "./context/publications-context";
import { PublicationsComponent } from "./publications-component";

export function PublicationsFactory() {
    return (
        <BaseLayoutFactory>
            <PublicationsProvider>
                <PublicationsComponent />
            </PublicationsProvider>
        </BaseLayoutFactory>
    );
}
